export var BusinessLocationType;
(function (BusinessLocationType) {
    BusinessLocationType["ON_LOCATION"] = "LOCAL";
    BusinessLocationType["ON_THE_GO"] = "ON_THE_GO";
    BusinessLocationType["UNDEFINED"] = "UNDEFINED";
})(BusinessLocationType || (BusinessLocationType = {}));
export var TimezoneType;
(function (TimezoneType) {
    TimezoneType["BUSINESS"] = "business";
    TimezoneType["CLIENT"] = "client";
})(TimezoneType || (TimezoneType = {}));
//# sourceMappingURL=business.dto.js.map